import { useState, useEffect } from "react";
import CustomCard from "../../common/components/CustomCard";
import CustomModal from "../../common/components/CustomModal";
import { Program, ProgramQuestionMap } from "../../pages/Registration";

interface CustomContentProps {
    formData:Record<string, any>;
    pqm: ProgramQuestionMap;
    allocatedProgram?: Program | null
    isShowModal: boolean;
    setModalDisplay: (display: boolean) => void;
}
const CustomContent: React.FC<CustomContentProps> = ({
    formData,
    pqm,
    allocatedProgram,
    isShowModal,
    setModalDisplay
}) => {
    const [isModalOpen, setModalOpen] = useState(true);

    // Reset modal open state when the radio value changes and should show modal
    useEffect(() => {
        if (
            formData &&
            pqm?.question?.config?.showDialog?.type === "popup" &&
            formData[pqm.question.id] === pqm?.question?.config?.showDialog?.isShow
        ) {
            setModalOpen(true);
        } else {
            setModalOpen(false);
        }
    }, [formData[pqm.question.id], pqm?.question?.config?.showDialog?.isShow]);

    const handleModalClose = () => {
        setModalDisplay(false);
        setModalOpen(false);
    };
    return (
        <>
            {formData &&
                pqm?.question?.config?.showDialog?.type ===
                "popup" &&
                formData[pqm.question.id] ==
                pqm?.question?.config?.showDialog
                    ?.isShow && (
                    <CustomModal
                        open={
                            formData[pqm.question.id] == pqm?.question?.config?.showDialog?.isShow && isModalOpen
                        }
                        onclose={handleModalClose}
                        description={
                            pqm?.question?.config?.showDialog
                                ?.dialogueContent
                        }
                        onConfirm={handleModalClose}
                        confirmText={"okay"}
                        allocatedProgram = {allocatedProgram}
                        question = {pqm.question}
                        isShowModal = {isShowModal}
                    />
                )}
            {pqm.question?.config?.showDialogMessage?.map((item, index: number) => {
                const questionValue = formData?.[pqm.question.id];
                if (
                    item.type === "card" &&
                    formData &&
                    questionValue === item?.isShow
                ) {
                    return (
                        <CustomCard
                            allocatedProgram={allocatedProgram}
                            key={item.type + index}
                            cardContent={item}
                            question={pqm.question}
                            content={item?.dialogueContent}
                        />
                    );
                }
                return null;
            })}
        </>
    )
}

export default CustomContent;